import {
  GET_ALL_IN_BRANCH,
  GET_MONTHLY_INVENTORY_DATA,
  LOAD_MORE_MONTHLY_INVENTORY_DATA,
} from "../types";
import axios from "axios";
import { firebase } from "../../../firebase/initFirebase";
import moment from "moment";
import { store } from "../../store";
import { message } from "antd";
import S3 from "react-aws-s3";

export const getMonthlyInventoryData = (props) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var userLocation = reduxState.auth.user.branch;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("monthlyaudit");
    // console.log(props)

    dataRef = dataRef.orderBy("created_at", "desc");

    dataRef = dataRef.where("status", "==", "completed");

    if (userRole !== "admin" && userRole !== "manager") {
      dataRef = dataRef.where("branch", "==", userLocation);
    }

    // if(props.searchText){
    //   dataRef = dataRef.orderBy('name').startAt(props.searchText).endAt(props.searchText + '\uf8ff')
    // }
    // if(props.filters){
    //   if(props.filters.length > 0){
    //     props.filters.map(item=>{
    //       console.log(item)
    //       dataRef = dataRef.orderBy(item.dataIndex).startAt(item.value).endAt(item.value + '\uf8ff')
    //     })
    //   }
    // }

    dataRef = dataRef.limit(40);

    var documentSnapshots = await dataRef.get();
    var docs = documentSnapshots.docs;
    var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    var dataArray = [];

    await Promise.all(
      docs.map(async (salesItem) => {
        var newOrder = {
          key: salesItem.id,
          id: salesItem.id,
          ...salesItem.data(),
        };

        dataArray.push(newOrder);
      })
    );
    dispatch({
      type: GET_MONTHLY_INVENTORY_DATA,
      payload: {
        dataArray: dataArray,
        lastVisible: lastVisible,
        currentProps: props,
      },
    });
  };
};

export const loadMoreMonthlyInventoryData = () => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var currentLastItem = reduxState.dailysales.lastVisible;
    var userLocation = reduxState.auth.user.branch;
    var currentProps = reduxState.dailysales.currentProps;
    var Firestore = firebase.firestore();

    var dataRef = Firestore.collection(currentProps.apiurl);

    dataRef = dataRef.orderBy("created_at", "desc");

    dataRef = dataRef.where("status", "==", "completed");

    if (userRole !== "admin" && userRole !== "manager") {
      dataRef = dataRef.where("branch", "==", userLocation);
    }

    if (currentLastItem) {
      dataRef = dataRef.startAfter(currentLastItem);

      // if(currentProps.searchText){
      //   dataRef = dataRef.where('name', '>=', currentProps.searchText).where('name', '<=', currentProps.searchText+ '\uf8ff')
      // }

      dataRef = dataRef.limit(100);

      var documentSnapshots = await dataRef.get();
      var docs = documentSnapshots.docs;
      if (docs) {
        var lastVisible =
          documentSnapshots.docs[documentSnapshots.docs.length - 1];
        var dataArray = [];
        await Promise.all(
          docs.map(async (salesItem) => {
            var newOrder = {
              key: salesItem.id,
              id: salesItem.id,
              ...salesItem.data(),
            };

            dataArray.push(newOrder);
          })
        );
        if (lastVisible && currentLastItem !== lastVisible) {
          dispatch({
            type: LOAD_MORE_MONTHLY_INVENTORY_DATA,
            payload: { dataArray: dataArray, lastVisible: lastVisible },
          });
        } else {
          message.error("No More Orders To Load");
        }
      } else {
        message.error("No More Orders To Load");
      }
    }
  };
};

export const setalltoFalse = (props) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    const productsRef = Firestore.collection("products");
    const snapshot = await productsRef.get();

    const batch = Firestore.batch();

    snapshot.docs.forEach((doc) => {
      const docRef = productsRef.doc(doc.id);
      batch.update(docRef, { excludeFromAudit: false });
    });

    await batch.commit();
    console.log("All documents updated successfully");
  };
};

export const getInBranchItems = (props) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var applyBrandFilter = false;
    if (userRole == "oic") {
      applyBrandFilter = true;
    }
    var Firestore = firebase.firestore();
    var productdataRef = Firestore.collection("products");

    var productdataRef1 = productdataRef
      .where("menu_item", "==", false)
      .orderBy("category_name", "desc");
    var productdataRef2 = productdataRef
      .where("is_premix", "==", true)
      .orderBy("category_name", "desc");

    var documentSnapshots1 = await productdataRef1.get();
    var documentSnapshots2 = await productdataRef2.get();

    var varname = `${userLocation}_count`;
    var newProds = [];
    var newProds_premix = [];
    const existingIds = [];
    // get documents for first condition
    var proddocs1 = documentSnapshots1.docs;
    await Promise.all(
      proddocs1.map(async (item) => {
        var newProd = {
          key: item.id,
          id: item.id,
          ...item.data(),
        };

        if (
          newProd?.[varname] !== undefined &&
          (newProd.excludeFromAudit == false ||
            newProd.excludeFromAudit == undefined)
        ) {
          existingIds.push(item.id);
          newProds.push(newProd);
        }
      })
    );

    // get documents for second condition
    var proddocs2 = documentSnapshots2.docs;
    await Promise.all(
      proddocs2.map(async (item) => {
        var newProd = {
          key: item.id,
          id: item.id,
          ...item.data(),
        };
        if (!existingIds.includes(item.id)) {
          // get ingredients subcollection
          var ingredientsSnapshot = await productdataRef
            .doc(item.id)
            .collection("ingredients")
            .get();
          newProd.ingredients = ingredientsSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

          // if (
          //   applyBrandFilter &&
          //   newProd?.brand_name &&
          //   newProd.brand_name.length > 0
          // ) {
          //   if (
          //     userLocationName == "Pause" &&
          //     newProd.brand_name.includes("Pause")
          //   ) {
          //     newProds_premix.push(newProd);
          //   } else if (
          //     userLocationName !== "Pause" &&
          //     newProd.brand_name.includes("Lala and Co")
          //   ) {
          //     newProds_premix.push(newProd);
          //   }
          // } else {

          // }
          newProds_premix.push(newProd);
        }
      })
    );

    var payload = {
      inventory: newProds,
      premix: newProds_premix,
    };
    // dispatch newProds to redux store
    dispatch({ type: GET_ALL_IN_BRANCH, payload: payload });
  };
};

export const setMonthlyInventory = (
  audited_items,
  createDate,
  currentWeighted
) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var auditRef = Firestore.collection("monthlyaudit").doc();

    var auditData = {
      status: "completed",
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      created_by: userID,
      created_name: userName,
      branch: userLocation,
      branch_name: userLocationName,
      audited_items: audited_items,
      weighted_exchange: currentWeighted,
    };

    var auditdone = await auditRef.set(auditData);

    return "oks";
  };
};

export const updateMonthlyInventory = (audit) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var auditRef = Firestore.collection("monthlyaudit").doc(audit.id);

    var auditData = {
      ...audit,
      updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      updated_by: userID,
      updated_name: userName,
    };

    var auditdone = await auditRef.set(auditData, { merge: true });

    return "oks";
  };
};

export const approveMonthlyInventory = (id) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var auditRef = Firestore.collection("monthlyaudit").doc(id);

    var auditData = {
      checked_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      checked_by: userID,
      checked_name: userName,
    };

    var auditdone = await auditRef.set(auditData, { merge: true });

    return "oks";
  };
};

export const getLatestAuditofcurrentBranch = (props) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var userLocation = reduxState.auth.user.branch;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("monthlyaudit");
    // console.log(props)

    dataRef = dataRef.orderBy("created_at", "desc");
    dataRef = dataRef.where("status", "==", "completed");
    dataRef = dataRef.where("branch", "==", userLocation);

    dataRef = dataRef.limit(1);

    var documentSnapshots = await dataRef.get();
    var docs = documentSnapshots.docs;
    var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    var newOrder = {};
    await Promise.all(
      docs.map(async (salesItem) => {
        newOrder = {
          key: salesItem.id,
          id: salesItem.id,
          ...salesItem.data(),
        };
      })
    );
    if (newOrder?.id) {
      return newOrder;
    } else {
      return "none";
    }
  };
};
